// import request from '../utils/http'
import request from '@/utils/request-primary'
import { removeToken } from '@/utils/auth'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    url: '/studentLogin',
    method: 'post',
    data: data
  })
}
// 修改密码
export function studentResetPws(oldpassword,newpassword) {
  const data = {
    oldpassword,
    newpassword
  }
  return request({
    url: '/studentResetPws',
    method: 'post',
    data: data
  })
}
// 找回密码
export function studentFindPws(data) {
  return request({
    url: '/studentFindPws',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  removeToken()
  location.search = setParms({"_jwt":""})
  return request({
    url: '/logout',
    method: 'post'
  })
}

export function jwtLogin(data) {
  return request({
    url: '/studentJwtLogin',
    method: 'post',
    data
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  })
}

function setParms(args) {
  var parms = {}, newParms = '?';
  //把location.search解析成对象parms
  var query = location.search.substring(1).split('&');
  for (var i = 0; i < query.length; i++) {
    var pos = query[i].split('=');
    if (pos[0]) {
      parms[pos[0]] = pos[1] ? pos[1] : '';
    }
  }
  //如果没有传设置的args,则直接返回parms
  if (!args) {
    return parms;
  }
  //设置parms,属性存在则更新,不存在则添加
  for (var argKey in args) {
    for (var parmskey in parms) {
      if (argKey === parmskey) {
        parms[parmskey] = args[parmskey];
        break;
      }
    }
    parms[argKey] = args[argKey];
  }
  //字符串化parms并返回
  for (var key in parms) {
    if(parms[key] !== ""){
      newParms += key + '=' + parms[key] + '&';
    }
  }
  return newParms.substring(0, newParms.length - 1);
}